/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ExistingRouterCoordinates,
  HandoffRouterDraft,
  LaunchRouteResponse,
  LaunchRoutingRequest,
  MapString,
  PublicHandoffDraftWithRouter,
  PublicRoutingInfoResponse,
  RoutingAcceptedState,
  ScheduleMeetingRequestAdmin,
  ScheduleMeetingRequestPublic,
  ScheduleMeetingResult,
  SelectRouteRequest,
  SelectRouteResponse,
  Settings,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "handoff";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description List workspaces with active handoff router
   *
   * @tags router
   * @name ListWorkspacesWithActiveHandoffRouter
   * @request GET:/v1/tenant/{tenantId}/workspace/active
   * @secure
   */
  listWorkspacesWithActiveHandoffRouter = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      string[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/active`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listWorkspacesWithActiveHandoffRouter */
  listWorkspacesWithActiveHandoffRouterPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/active`);

  /**
   * @description List handoff routers & drafts
   *
   * @tags router
   * @name ListRouters
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/routers
   * @secure
   */
  listRouters = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      PublicHandoffDraftWithRouter[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/routers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listRouters */
  listRoutersPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/routers`);

  /**
   * @description Update handoff router draft
   *
   * @tags router
   * @name UpdateRouter
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/router/update
   * @secure
   */
  updateRouter = (tenantId: string, workspaceId: string, data: HandoffRouterDraft, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/router/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateRouter */
  updateRouterPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/router/update`);

  /**
   * @description Publish handoff router draft changes
   *
   * @tags router
   * @name PublishRouter
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/router/publish
   * @secure
   */
  publishRouter = (
    tenantId: string,
    workspaceId: string,
    data: ExistingRouterCoordinates,
    params: RequestParams = {},
  ) =>
    this.request<
      HandoffRouterDraft,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/router/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publishRouter */
  publishRouterPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/router/publish`);

  /**
   * @description Get handoff router & draft
   *
   * @tags router
   * @name GetRouter
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/router/{routerId}
   * @secure
   */
  getRouter = (tenantId: string, workspaceId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      PublicHandoffDraftWithRouter,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getRouter */
  getRouterPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}`);

  /**
   * @description Delete handoff router & draft
   *
   * @tags router
   * @name DeleteRouter
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/router/{routerId}
   * @secure
   */
  deleteRouter = (tenantId: string, workspaceId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteRouter */
  deleteRouterPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}`);

  /**
   * @description Create handoff router draft
   *
   * @tags router
   * @name CreateRouter
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/routers/new
   * @secure
   */
  createRouter = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      HandoffRouterDraft,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/routers/new`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createRouter */
  createRouterPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/routers/new`);

  /**
   * @description Allow or forbid routing
   *
   * @tags router
   * @name AllowRouting
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/router/{routerId}/allow-routing
   * @secure
   */
  allowRouting = (
    tenantId: string,
    workspaceId: string,
    routerId: string,
    data: RoutingAcceptedState,
    params: RequestParams = {},
  ) =>
    this.request<
      HandoffRouterDraft,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}/allow-routing`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for allowRouting */
  allowRoutingPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}/allow-routing`);

  /**
   * @description Creates a copy of the router, uses existing draft as source. Doesn't publish the router even if source is published
   *
   * @tags router
   * @name DuplicateRouter
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/router/{routerId}/duplicate
   * @secure
   */
  duplicateRouter = (tenantId: string, workspaceId: string, routerId: string, params: RequestParams = {}) =>
    this.request<
      HandoffRouterDraft,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}/duplicate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for duplicateRouter */
  duplicateRouterPathGetter = (tenantId: string, workspaceId: string, routerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/router/${routerId}/duplicate`);

  /**
   * @description First step of the handoff. Matches against the routers in the workspace & returns ordered list of routers. and a rule for the user, based on the criteria used to match the prospect at the flow builder level. If multiple rules match for the same prospect, we pre-select one based on the type of rule that the prospect matched: * Ownership Rules * Non-Ownership Rules * Catch-all Rule If the prospect matched same type rules in different routers, we default to the Router that has more rules than the other If all are the same, we pre-select the latest used router
   *
   * @tags routing
   * @name LaunchRoutersInAWorkspace
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/launch
   * @secure
   */
  launchRoutersInAWorkspace = (
    tenantId: string,
    workspaceId: string,
    data: LaunchRoutingRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      LaunchRouteResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/launch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for launchRoutersInAWorkspace */
  launchRoutersInAWorkspacePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/launch`);

  /**
   * @description Second step of the handoff. Selects a particular route (router -> rule) in routing instance. That implies assignee selection gets attached to this routingId. Selecting route means either: * Creating suggested times * Creating scheduling link * Booking directly into calendar of a prospect (this is a terminal state).
   *
   * @tags routing
   * @name SelectParticularPathAssigneeInARoutingId
   * @request POST:/v1/tenant/{tenantId}/routing/{routingId}/router/{routerId}/path/{pathId}/select
   * @secure
   */
  selectParticularPathAssigneeInARoutingId = (
    tenantId: string,
    routingId: string,
    routerId: string,
    pathId: string,
    data: SelectRouteRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SelectRouteResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/routing/${routingId}/router/${routerId}/path/${pathId}/select`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for selectParticularPathAssigneeInARoutingId */
  selectParticularPathAssigneeInARoutingIdPathGetter = (
    tenantId: string,
    routingId: string,
    routerId: string,
    pathId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/routing/${routingId}/router/${routerId}/path/${pathId}/select`);

  /**
   * @description Initiate scheduling step of the routing flow. Proxies it to meetings platform, while storing some information in handoff.
   *
   * @tags routing
   * @name ScheduleMeetingWithinAParticularRoutingIdPublic
   * @request POST:/v1/public/tenant/{tenantId}/routing/{routingId}/schedule
   */
  scheduleMeetingWithinAParticularRoutingIdPublic = (
    tenantId: string,
    routingId: string,
    data: ScheduleMeetingRequestPublic,
    params: RequestParams = {},
  ) =>
    this.request<
      ScheduleMeetingResult,
      | string
      | ScheduleMeetingResult
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/routing/${routingId}/schedule`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for scheduleMeetingWithinAParticularRoutingIdPublic */
  scheduleMeetingWithinAParticularRoutingIdPublicPathGetter = (tenantId: string, routingId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/routing/${routingId}/schedule`);

  /**
   * @description Initiate scheduling step of the routing flow. Proxies it to meetings platform, while storing some information in handoff. Supports scheduling directly to calendar.
   *
   * @tags routing
   * @name ScheduleMeetingWithinAParticularRoutingIdAdmin
   * @request POST:/v1/tenant/{tenantId}/routing/{routingId}/schedule
   * @secure
   */
  scheduleMeetingWithinAParticularRoutingIdAdmin = (
    tenantId: string,
    routingId: string,
    data: ScheduleMeetingRequestAdmin,
    params: RequestParams = {},
  ) =>
    this.request<
      ScheduleMeetingResult,
      | string
      | ScheduleMeetingResult
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/routing/${routingId}/schedule`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for scheduleMeetingWithinAParticularRoutingIdAdmin */
  scheduleMeetingWithinAParticularRoutingIdAdminPathGetter = (tenantId: string, routingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/routing/${routingId}/schedule`);

  /**
   * @description Get public routing info by routingId
   *
   * @tags routing
   * @name GetPublicRoutingInfo
   * @request GET:/v1/public/tenant/{tenantId}/routing/{routingId}/public
   */
  getPublicRoutingInfo = (tenantId: string, routingId: string, params: RequestParams = {}) =>
    this.request<
      PublicRoutingInfoResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/routing/${routingId}/public`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPublicRoutingInfo */
  getPublicRoutingInfoPathGetter = (tenantId: string, routingId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/routing/${routingId}/public`);

  /**
   * @description Get handoff settings
   *
   * @tags router
   * @name GetSettings
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings
   * @secure
   */
  getSettings = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      Settings,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSettings */
  getSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`);

  /**
   * @description Update handoff settings
   *
   * @tags router
   * @name UpdateSettings
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/settings
   * @secure
   */
  updateSettings = (tenantId: string, workspaceId: string, data: Settings, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateSettings */
  updateSettingsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/settings`);
}
